import { Tab, useTranslate } from 'react-admin';
import { PaperTabbedShowLayout } from '~/layout';
import ConfigurationTab from '~/resources/ledgers/mambu/components/ConfigurationTab';
import StatusTab from '~/resources/ledgers/mambu/components/StatusTab';
import React from 'react';
import { l } from '~/resources/ledgers/mambu/components/ConfigurationForm';
import ShowTitle from '~/layout/RecordTitle';

const MambuShow = (props: any) => {
  const { resource } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <PaperTabbedShowLayout {...props}>
      <Tab label={t('tabs.status')}>
        <StatusTab />
      </Tab>
      <Tab label={t('tabs.configuration')} path='configuration'>
        <ConfigurationTab resource={resource} />
      </Tab>
    </PaperTabbedShowLayout>
  );
};

const ShowController = (props: any) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <>
      <ShowTitle
        record={{}}
        resource={props.resource}
        headline={() => t('name')}
        subtitle={() => t('subtitle')}
      />
      <MambuShow {...props} />
    </>
  );
};

export default ShowController;
